var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46406 12.7753C9.46861 11.5181 11.7597 8.47119 11.7597 6.75973C11.7597 4.68405 10.0756 3 7.99996 3C5.92428 3 4.24023 4.68405 4.24023 6.75973C4.24023 8.47119 6.53132 11.5181 7.53587 12.7753C7.77673 13.0749 8.2232 13.0749 8.46406 12.7753ZM7.99996 8.01297C7.30872 8.01297 6.74672 7.45097 6.74672 6.75973C6.74672 6.06849 7.30872 5.50649 7.99996 5.50649C8.69121 5.50649 9.25321 6.06849 9.25321 6.75973C9.25321 7.45097 8.69121 8.01297 7.99996 8.01297Z",
    fill: "#6D738D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8319c2ef9d9358e20f42dab0196af5d8.svg";
export { ForwardRef as ReactComponent };